import React from 'react';
import { useTranslation } from 'react-i18next';
import { Formik, Form } from 'formik';
import SuperPaymentForm from '../components/SuperPaymentForm';
import * as Yup from 'yup';
import FormTextField from '../components/FormTextField';
import { useAppSelector } from '../app/hooks';
import { OrderingConstants, OrderingSelectors } from 'polygon-ordering';
import PaymentProvider from '../components/PaymentProvider';
import { TyroProvider } from '../hooks/TyroProvider';

export const MEMBER_MONEY_ROUTE = '/member-money';

const { getGatewayType } = OrderingSelectors;
const { PAYMENT_GATEWAY_TYPES } = OrderingConstants;

const MemberMoneyScreen = () => {
  const { t } = useTranslation();
  const handleFormSubmit = () => {};
  const schemas = {
    Amount: Yup.string().required(t('form.required')),
  };
  const validationSchema = Yup.object().shape(schemas);

  const gatewayType = useAppSelector(getGatewayType);
  let PaymentProviderWrapper: any;

  if (gatewayType === PAYMENT_GATEWAY_TYPES.STRIPE) {
    PaymentProviderWrapper = PaymentProvider;
  } else if (gatewayType === PAYMENT_GATEWAY_TYPES.TYRO) {
    PaymentProviderWrapper = TyroProvider;
  }

  return (
    <PaymentProviderWrapper>
      <div className="text-center py-2">
        <Formik
          validationSchema={validationSchema}
          initialValues={{ Amount: '' }}
          onSubmit={handleFormSubmit}
        >
          {({ handleSubmit, handleChange }) => (
            <Form onSubmit={handleSubmit}>
              <FormTextField
                onChange={e => {
                  handleChange(e);
                }}
                name="Amount"
                type="number"
                required={true}
                label={t('placeholder.giftcardAmount')}
              />
              <SuperPaymentForm route="memberCashTopUp" />
            </Form>
          )}
        </Formik>
      </div>
    </PaymentProviderWrapper>
  );
};

export default MemberMoneyScreen;
